<div class="min-progress-bar">
  <div class="progress-bar-fill" [ngStyle]="{'width': fillSizeValue + '%'}"></div>
</div>
